import { newAPI } from 'services';
import qs from 'qs';

export const fetchCalendarServices = async (userId, establishmentId, startDateTime, endDateTime, qp) => {
  const response = await newAPI.get(`/${userId}/establishment/${establishmentId}/event_scheduling/calendar/list?startDateTime=${startDateTime}&endDateTime=${endDateTime}${qp}`);
  return response.data;
}

export const fetchMapServices = async (userId, establishmentId, startDateTime, endDateTime, qp) => {
  const response = await newAPI.get(`/${userId}/establishment/${establishmentId}/event_scheduling/map/list?startDateTime=${startDateTime}&endDateTime=${endDateTime}${qp}`);
  return response.data;
}

export const fetchAllServices = async (userId, establishmentId) => {
  const response = await newAPI.get(`/${userId}/establishment/${establishmentId}/event_scheduling`);
  return response.data;
}

export const fetchCalendarExport = async (userId, establishmentId, startDateTime, endDateTime, qp) => {
  const response = await newAPI.get(`/${userId}/establishment/${establishmentId}/event_scheduling/calendar/export?startDateTime=${startDateTime}&endDateTime=${endDateTime}${qp}`);
  return response.data;
}

export const fetchMapExport = async (userId, establishmentId, startDateTime, endDateTime, qp) => {
  const response = await newAPI.get(`/${userId}/establishment/${establishmentId}/event_scheduling/map/export?startDateTime=${startDateTime}&endDateTime=${endDateTime}${qp}`);
  return response.data;
}

export const requestBulkUpdateDateTime = async (userId, establishmentId, events) => {
  const response = await newAPI.put(`/${userId}/establishment/${establishmentId}/event_scheduling/services/bulk-update-datetime`, qs.stringify(events));
  return response.data;
}